<template>
  <b-form-group label="Grup" label-for="id_feature_groups">
    <validation-provider #default="{ errors }" name="Grup" rules="required">
      <v-select
          v-model="dataItem.id_feature_groups"
          :options="dataList"
          label="title"
          :reduce="item => item.id"
          placeholder="Grup"
          @input="onGroupChange"
      >
        <template v-slot:option="option">
          <div>
            {{ option.title }}
          </div>
        </template>
      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>

    <!-- Eğer özel başlıklardan biri seçiliyse renk paleti göster -->
    <div v-if="showColorPicker" class="mt-3">
      <label class="form-label">Renk Kodu</label>
      <input
          type="color"
          v-model="dataItem.code"
          class="form-control form-control-color"
      />
      <div class="mt-2">Seçilen Renk: {{ dataItem.code }}</div>
    </div>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import { BFormGroup } from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'FeatureGroups',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
      showColorPicker: false,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['featureGroups/dataList']
    },
    dataItem() {
      return this.$store.getters['features/dataItem']
    },
  },
  mounted() {
    this.checkColorPicker(this.dataItem.id_feature_groups)
  },

  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('featureGroups/getDataList', {
        select: [
          'feature_groups.id AS id',
          'feature_groups.title AS title',
        ],
      })
    },
    checkColorPicker(selectedId) {
      const selected = this.dataList.find(item => item.id === selectedId)
      if (selected && (selected.title === 'Üretimde Mevcut Renkler' || selected.title === 'Standart Popüler Renkler')) {
        this.showColorPicker = true
      } else {
        this.showColorPicker = false
        this.dataItem.code = null
      }
    },
    onGroupChange(selectedId) {
      this.checkColorPicker(selectedId)
    },
  },
}
</script>
